<div class="d-flex justify-content-between align-items-center">
  <div>
    <h2 class="h3 mb-0">
      {{ 'dashboard.widgets.open-consults.title' | translate }}
    </h2>

    <div class="small text-secondary">
      <fa-icon [icon]="'stethoscope'" class="text-primary"></fa-icon>
      {{ 'dashboard.widgets.open-consults.count' | translate: { count: openConsultsCount() } }}
    </div>
  </div>

  <button class="btn btn-primary" type="button" [routerLink]="['/open-consults']">
    <fa-icon [icon]="'stethoscope'" class="me-1"></fa-icon>
    {{ 'dashboard.widgets.open-consults.button' | translate }}
  </button>
</div>
